module.exports = __webpack_public_path__ + "static/img/uv-icon.9fa0528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uv-icon.png
// module id = iz7r
// module chunks = 4